import httpRequest from "./../infrastructure/httphelper";
import sharedGlobals from "../sharedglobals";
import * as appUtilityfunctions from "../infrastructure/apputilityfunctions";
import * as appConstants from "../overrides/appconstants";
import * as sharedConstants from "../constants/sharedContants";
class SecurityService {
    constructor() { }


    setAuthCookie(sessionToken) {
        localStorage.setItem("sessionToken", sessionToken);
        document.cookie = "sessionToken=" + sessionToken;
    }
    setSession(userSession) {
        sharedGlobals.sessionToken = userSession.sessionToken;
        this.setAuthCookie(userSession.sessionToken);
    }
    getAuthToken() {
        var authKey = appUtilityfunctions.readCookie('sessionToken');
        if (authKey == null || authKey == '') {
            authKey = localStorage.getItem('sessionToken');
        }
        if (authKey == null || authKey == '')
            return null;
        return decodeURIComponent(authKey);
    }
    getUserSessionByToken() {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUserSession";
        return httpRequest({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer  ' + this.getAuthToken()
            }
        });
    }
    getUsersByMicrosoftLogin(token) {
        let url =
            sharedGlobals.appUrls.securityApiUrl + "api/Security/GetUsersByMicrosoftLogin";
        return httpRequest({
            url: url,
            method: "POST",
            params:{
                token
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer  ' + this.getAuthToken()
            }
        });
    }
    createUserSessionFromMicrosoftLogin(token,userId){
        let url =
        sharedGlobals.appUrls.securityApiUrl + "api/Security/CreateUserSessionFromMicrosoftLogin";
        return httpRequest({
            url: url,
            method: "POST",
            params:{
                token,
                userId
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer  ' + this.getAuthToken()
            }
    });
    }
    hasMenus(menus, menusToCheck, requireAllMenus) {
        let validMenus = [];
        menusToCheck.forEach(menuToCheck => {
            if (menus.find(p => p.menuId == menuToCheck)) {
                validMenus.push(menuToCheck);
            }
        });
        if (requireAllMenus) {
            return validMenus.length == menus.length;
        }
        return validMenus.length > 0;
    }
    getSystemUrl(menus, pageId) {
        let page = menus.find(p => p.menuId == pageId);
        if (page.menuType == 1) {
            return this.getSystemUrlFromSystemMenuId(page.menuId)
        }
        let module = menus.find(p => p.menuId == page.parentMenuId);
        if (module.menuType == 1) {
            return this.getSystemUrlFromSystemMenuId(module.menuId)
        }
        let system = menus.find(p => p.menuId == module.parentMenuId);
        if (system.menuType == 1) {
            return this.getSystemUrlFromSystemMenuId(system.menuId)
        }
        return this.getSystemUrlFromSystemMenuId(page.menuId);
    }
    getSystemUrlFromSystemMenuId(menuId) {
        if (menuId == sharedConstants.SYSTEM_MENU_IDS.MICore) {
            return sharedGlobals.appUrls.miCoreUrl;
        } else if (menuId == sharedConstants.SYSTEM_MENU_IDS.MIBroker) {
            return sharedGlobals.appUrls.miBrokerUrl;
        }else if (menuId == sharedConstants.SYSTEM_MENU_IDS.Finance) {
            return sharedGlobals.appUrls.financeUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.GICore) {
            return sharedGlobals.appUrls.giCoreUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.GIPortal) {
            return sharedGlobals.appUrls.giPortalUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.Security) {
            return sharedGlobals.appUrls.ssoUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.ComplaintsCore) {
            return sharedGlobals.appUrls.complaintsCoreUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.RICore) {
            return sharedGlobals.appUrls.riCoreUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.CRMCore) {
            return sharedGlobals.appUrls.crmCoreUrl;
        }
        else if (menuId == sharedConstants.SYSTEM_MENU_IDS.MotorClaims) {
            return sharedGlobals.appUrls.motorClaimsUrl;
        }
        return sharedGlobals.appUrls.ssoUrl + 'dashboard';
    }
    getSystemMenuId(menus, pageId) {
        let page = menus.find(p => p.menuId == pageId);
        if (page.menuType == 1) {
            return page.menuId;
        }
        let module = menus.find(p => p.menuId == page.parentMenuId);
        if (module.menuType == 1) {
            return page.menuId;
        }
        let system = menus.find(p => p.menuId == module.parentMenuId);
        if (system.menuType == 1) {
            return page.menuId;
        }
        return null;
    }
    getSystemUrlFromSystemId(systmId) {
        if (systmId == sharedConstants.SYSTEM_MENU_IDS.MICore) {
            return sharedGlobals.appUrls.miCoreUrl;
        } else if (systmId == sharedConstants.SYSTEM_MENU_IDS.MIBroker) {
            return sharedGlobals.appUrls.miBrokerUrl;
        }else if (systmId == sharedConstants.SYSTEM_MENU_IDS.Finance) {
            return sharedGlobals.appUrls.financeUrl;
        }
        else if (systmId == sharedConstants.SYSTEM_MENU_IDS.RICore) {
            return sharedGlobals.appUrls.riCoreUrl;
        }
        else if (systmId == sharedConstants.SYSTEM_MENU_IDS.GIPortal) {
            return sharedGlobals.appUrls.giPortalUrl;
        }
        else if (systmId == sharedConstants.SYSTEM_MENU_IDS.ComplaintsCore) {
            return sharedGlobals.appUrls.complaintsCoreUrl;
        } else if (systmId == sharedConstants.SYSTEM_MENU_IDS.RICore) {
            return sharedGlobals.appUrls.riCoreUrl;
        }
        else if (systmId == sharedConstants.SYSTEM_MENU_IDS.CRMCore) {
            return sharedGlobals.appUrls.crmCoreUrl;
        }
        else if (systmId == sharedConstants.SYSTEM_MENU_IDS.MotorClaims) {
            return sharedGlobals.appUrls.motorClaimsUrl;
        }
        
        return sharedGlobals.appUrls.ssoUrl + 'dashboard';
    }

}
let instance = new SecurityService();
export default instance;
